interface ReportAbuseLinkParams {
    category?: string;
    objectId: number;
    objectType: string;
    extraParams?: Record<string, string>;
}

export const reportAbuseLink = ({
    category,
    objectId,
    objectType,
    extraParams,
}: ReportAbuseLinkParams) => {
    const path = '/feedback/report/';
    const searchParams = new URLSearchParams();
    searchParams.set('related_object_type', objectType);
    searchParams.set('related_object_id', objectId.toString());
    if (category) {
        searchParams.set('category', category);
    }
    if (extraParams) {
        Object.entries(extraParams).forEach(([k, v]) => {
            searchParams.set(k, v);
        });
    }

    return `${path}?${searchParams.toString()}`;
};
